import { Check, Circle } from "lucide-react";
import { scorePassword } from "@/lib/authHelpers";

export function PasswordStrength({ password }) {
  const s = scorePassword(password);
  const reqs = [
    { ok: s.checks.len, txt: "Minimum 8 characters" },
    { ok: s.checks.letter, txt: "At least 1 letter" },
    { ok: s.checks.number, txt: "At least 1 number" },
  ];
  return (
    <div className="mt-2" data-testid="password-strength">
      <div className="flex gap-1 mb-1.5">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="h-1 flex-1 rounded-full transition-colors"
            style={{ background: i <= s.level ? s.color : "#e2e8f0" }} />
        ))}
      </div>
      {s.label && (
        <div className="text-xs font-semibold mb-1" style={{ color: s.color }} data-testid="password-strength-label">
          {s.label}
        </div>
      )}
      <ul className="space-y-0.5">
        {reqs.map((r) => (
          <li key={r.txt} className={`flex items-center gap-1.5 text-xs ${r.ok ? "text-emerald-600" : "text-slate-400"}`}
            data-testid={`pw-req-${r.ok ? "met" : "unmet"}`}>
            {r.ok ? <Check className="h-3.5 w-3.5" /> : <Circle className="h-3 w-3" />}
            {r.txt}
          </li>
        ))}
        <li className="flex items-center gap-1.5 text-xs text-slate-400">
          <Circle className="h-3 w-3" /> Strong passwords are recommended
        </li>
      </ul>
    </div>
  );
}
